import { render, staticRenderFns } from "./issue-c-t-d-o.vue?vue&type=template&id=379356c4"
import script from "./issue-c-t-d-o.vue?vue&type=script&lang=js"
export * from "./issue-c-t-d-o.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports